import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import { cloneDeepObject, handleSectionTemplate } from '@/views/website/products/components/description/common/utils';
// import { normalizeImgSrc } from '../utils'

export const buildSectionFreestyle = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;
  const raw_html = suggestionFields.content?.raw_html || '';

  const fieldUpdate = {
    content: raw_html,
  };

  return {
    ...newSection,
    html: updateHtmlFromData.sectionFreestyle(newSection.html, fieldUpdate),
  };
};
